import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const RECENT_SURVEYS = 'recent surveys'
export const SEARCH_NAME = 'search name'
export const NAME = 'name'
export const CREATED = 'created'
export const EDIT = 'edit'
export const TEST_SURVEY = 'test survey'
export const QUOTAS = 'quotas'
export const PARTNER_LINK = 'partner link'
export const ADD_AGENT = 'add agent'
export const CLONE_SURVEY = 'clone survey'
export const SURVEY_PROPERTIES = 'survey properties'
export const DELETE = 'delete'
export const SURVEY = 'survey'
export const DELETE_MESSAGE = 'delete message'
export const PAUSING_SURVEY = 'pausing survey'
export const START_FIELD = 'start field'
export const CHANGE_STATUS_SUCCESS = 'change status success'
export const ACTIVATED = 'activated'
export const DEACTIVATED = 'deactivated'
export const SURVEY_DELETED = 'survey was deleted'

export default {
  [PORTUGUESE]: {
    [RECENT_SURVEYS]: 'Pesquisas Recentes',
    [SEARCH_NAME]: 'Nome da pesquisa',
    [NAME]: 'Nome',
    [CREATED]: 'Criado',
    [EDIT]: 'Editar',
    [TEST_SURVEY]: 'Teste da Pesquisa',
    [QUOTAS]: 'Cotas',
    [PARTNER_LINK]: 'Link do Parceiro',
    [ADD_AGENT]: 'Adicionar Agente',
    [CLONE_SURVEY]: 'Clonar Pesquisa',
    [SURVEY_PROPERTIES]: 'Propriedades da Pesquisa',
    [DELETE]: 'Deletar',
    [SURVEY]: 'pesquisa',
    [DELETE_MESSAGE]: name => `Tem certeza de que deseja excluir a pesquisa "${name}"?`,
    [PAUSING_SURVEY]: name =>
      `Ao pausar sua pesquisa "${name}", todas as respostas coletadas serão <strong>excluídas permanentemente</strong>. Antes de prosseguir, é altamente recomendável que você baixe todos os seus resultados na aba “Report”, ou crie um clone da sua pesquisa para realizar as modificações desejadas. Tem certeza que deseja prosseguir?`,
    [START_FIELD]: name =>
      `Tem certeza de que está pronto para iniciar o campo "${name}"?`,
    [CHANGE_STATUS_SUCCESS]: 'com sucesso.',
    [ACTIVATED]: 'ativada',
    [DEACTIVATED]: 'desativada',
    [SURVEY_DELETED]: 'A pesquisa foi excluída',
  },

  [ENGLISH]: {
    [RECENT_SURVEYS]: 'Recent Surveys',
    [SEARCH_NAME]: 'Search Name',
    [NAME]: 'Name',
    [CREATED]: 'Created',
    [EDIT]: 'Edit',
    [TEST_SURVEY]: 'Test Survey',
    [QUOTAS]: 'Quotas',
    [PARTNER_LINK]: 'Partner link',
    [ADD_AGENT]: 'Add Agent',
    [CLONE_SURVEY]: 'Clone Survey',
    [SURVEY_PROPERTIES]: 'Survey Properties',
    [DELETE]: 'Delete',
    [SURVEY]: 'survey',
    [DELETE_MESSAGE]: name => `Are you sure you want to delete the "${name}" survey?`,
    [PAUSING_SURVEY]: name =>
      `When pausing your "${name}" survey, all collected responses will be <strong>permanently deleted</strong>. Before proceeding, it is highly recommended that you download all your results from the “Report” tab, or create a clone of your survey to carry out the desired modifications. Are you sure you want to proceed?`,
    [START_FIELD]: name => `Are you sure you are ready to start field "${name}"?`,
    [CHANGE_STATUS_SUCCESS]: 'with success.',
    [ACTIVATED]: 'activated',
    [DEACTIVATED]: 'deactivated',
    [SURVEY_DELETED]: 'The survey was deleted',
  },

  [SPANISH]: {
    [RECENT_SURVEYS]: 'Encuestas Recientes',
    [SEARCH_NAME]: 'Buscar',
    [NAME]: 'Nombre',
    [CREATED]: 'Creado',
    [EDIT]: 'Modificar',
    [TEST_SURVEY]: 'Prueba de Encuesta',
    [QUOTAS]: 'Cuotas',
    [PARTNER_LINK]: 'Link panel externo',
    [ADD_AGENT]: 'Agregar Agente',
    [CLONE_SURVEY]: 'Replicar encuesta',
    [SURVEY_PROPERTIES]: 'Propiedades de la Encuesta',
    [DELETE]: 'Borrar',
    [SURVEY]: 'encuesta',
    [DELETE_MESSAGE]: name =>
      `¿Estás seguro de que quieres eliminar el encuesta "${name}"?`,
    [PAUSING_SURVEY]: name =>
      `Al pausar su encuesta "${name}", todas las respuestas recopiladas se <strong>eliminarán de forma permanente</strong>. Antes de continuar, es muy recomendable que descargue todos sus resultados desde la pestaña "Report", o cree una replica de su encuesta para realizar las modificaciones deseadas. ¿Estas seguro que deseas continuar?`,
    [START_FIELD]: name =>
      `¿Estás seguro de que estás listo para comenzar el campo "${name}"?`,
    [CHANGE_STATUS_SUCCESS]: 'con éxito.',
    [ACTIVATED]: 'activada',
    [DEACTIVATED]: 'desactivada',
    [SURVEY_DELETED]: 'La encuesta fue eliminada',
  },
}
